import React, { useEffect, useRef, useState } from 'react';
import style from '../css/Component_one.module.css';

function Component_one() {
	const [currentIndex, setCurrentIndex] = useState(0);

	// Your texts array (each step)
	const content = [
		{
			title: 'Welcome to Exporest',
			desc: 'We make corporate travel effortless. From booking flights, hotels, and cars, to handling last‑minute changes, we ensure your journey is smooth and efficient — so you can keep your focus on business.',
		},
		{
			title: 'Smarter Travel, Simplified Expenses',
			desc: 'Take the stress out of business trips. From quick team meetups to large corporate events, give your employees the freedom to travel confidently — while you stay in full control of budgets and visibility.',
		},
		{
			title: 'Clear Insights, Complete Control',
			desc: 'Exporest puts everything in one place — travel bookings, expense tracking, and company policies. Manage global or local trips with ease, keep costs in check, and never sacrifice your team’s experience.',
		},

		{
			title: 'Your Trusted Travel Partner',
			desc: 'Whether it’s a short domestic visit or a complex international trip, we personalize every travel plan. With dedicated support and expert care, Exporest brings you reliability, convenience, and peace of mind.',
		},
		{
			title: 'Why Companies Choose Exporest',
			desc: '✨ Competitive corporate rates\n✨ Tailored itineraries that align with your policies\n✨ 24/7 support from real experts (not bots)\n✨ Hassle‑free handling of group and team bookings',
		},
	];

	const textRef = useRef(null);

	// Animate on change
	useEffect(() => {
		if (textRef.current) {
			textRef.current.classList.remove(style.animateUp);
			void textRef.current.offsetWidth; // re-trigger animation
			textRef.current.classList.add(style.animateUp);
		}
	}, [currentIndex]);

	const handleNext = () => {
		setCurrentIndex((prev) => (prev + 1) % content.length);
	};

	const handlePrev = () => {
		setCurrentIndex((prev) => (prev - 1 + content.length) % content.length);
	};

	return (
		<div className={style.component_one}>
			<button onClick={handlePrev} className={style.navBtn}>
				⟨
			</button>
			<div ref={textRef} className={`${style.hidden} ${style.textBlock}`}>
				<h2 className={style.text2}>{content[currentIndex].title}</h2>
				<p className={style.text3}>
					{content[currentIndex].desc.split('\n').map((line, i) => (
						<span key={i}>
							{line}
							<br />
						</span>
					))}
				</p>
			</div>
			<button onClick={handleNext} className={style.navBtn}>
				⟩
			</button>
		</div>
	);
}

export default Component_one;
